import React from 'react';
import { LiquidityAmount } from '@akropolis-web/primitives';

import { colors, styled } from 'core/styles';
import { FormattedAmount } from 'components';

import { AreaSize } from '../types';

export function TvlLabel({ tvl, size }: { tvl: LiquidityAmount; size: AreaSize }) {
  return (
    <Root>
      <FormattedAmount sum={tvl} precision={2} symbolSize="inherit" withSI />
      {(size === 'large' || size === 'extra-large') && <span>&nbsp;TVL</span>}
    </Root>
  );
}

const Root = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  padding: '0px 7px',
  borderRadius: '100px',
  background: colors.blackOpacity[4],
});
